import { AHInput, AHText, Box, useSpaceSize } from "arkh";
import React from "react";
import { useIntlTokens } from "./mobile/useIntlTokens";

export const ContentTitlePreview = (props: { title: string }) => {
  return (
    <AHText type="title-small" space="medium">
      {props.title}
    </AHText>
  );
};

export const ContentTitleInput = (props: {
  title: string;
  setTitle(title: string): void;
  placeholder?: string;
  disabled?: boolean;

  autoFocus?: boolean;
}) => {
  const small = useSpaceSize("small");
  const intl_tokens = useIntlTokens();
  const placeholder = props.placeholder ?? intl_tokens.Title;
  return (
    <Box space="small">
      <AHInput
        autoFocus={props.autoFocus}
        placeholder={placeholder}
        hitSlop={{
          top: small,
          left: small,
          bottom: small,
          right: small,
        }}
        editable={!props.disabled}
        space="small"
        autoCapitalize="sentences"
        textType="title-small"
        cornerRadius="medium"
        numberOfLines={1}
        value={props.title}
        onChangeText={(t) => {
          if (t !== props.title) {
            props.setTitle(t);
          }
        }}
      />
    </Box>
  );
};
